import React, { Component } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from 'material-ui/TextField';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

const Landowners = [
  {
    LandownerCategoryID: 1,
    Name: "Bureau of Indian Affairs",
    Code: "BIA",
    LandownerKind: "Federal"
  },
  {
    LandownerCategoryID: 2,
    Name: "Bureau of Land Management",
    Code: "BLM",
    LandownerKind: "Federal"
  },
  {
    LandownerCategoryID: 3,
    Name: "Bureau of Reclamation",
    Code: "BOR",
    LandownerKind: "Federal"
  },
  {
    LandownerCategoryID: 4,
    Name: "Department of Defense",
    Code: "DOD",
    LandownerKind: "Federal"
  },
  {
    LandownerCategoryID: 5,
    Name: "Department of Energy",
    Code: "DOE",
    LandownerKind: "Federal"
  },
  {
    LandownerCategoryID: 6,
    Name: "National Park Service",
    Code: "NPS",
    LandownerKind: "Federal"
  },
  {
    LandownerCategoryID: 7,
    Name: "US Forest Service",
    Code: "USFS",
    LandownerKind: "Federal"
  },
  {
    LandownerCategoryID: 8,
    Name: "US Fish and Wildlife Service",
    Code: "USFWS",
    LandownerKind: "Federal"
  },
  {
    LandownerCategoryID: 9,
    Name: "Foreign Government",
    Code: "Foreign",
    LandownerKind: "Private"
  },
  {
    LandownerCategoryID: 10,
    Name: "Tribal Government (non-trust lands) or Alaska Native Corporation",
    Code: "Tribal",
    LandownerKind: "Other"
  },
  {
    LandownerCategoryID: 11,
    Name: "City or Equivalent Government",
    Code: "City",
    LandownerKind: "Other"
  },
  {
    LandownerCategoryID: 12,
    Name: "County or Equivalent Government",
    Code: "County",
    LandownerKind: "Other"
  },
  {
    LandownerCategoryID: 13,
    Name: "State or Equivalent Government",
    Code: "State",
    LandownerKind: "Other"
  },
  {
    LandownerCategoryID: 14,
    Name: "Individual or Private Corporation",
    Code: "Private",
    LandownerKind: "Private"
  },
  {
    LandownerCategoryID: 15,
    Name: "Alaska Native Claims Settlement Act",
    Code: "ANCSA",
    LandownerKind: "Private"
  },
  {
    LandownerCategoryID: 16,
    Name: "Other Local",
    Code: "OthLoc",
    LandownerKind: "Other"
  },
  {
    LandownerCategoryID: 18,
    Name: "Other Federal",
    Code: "OthFed",
    LandownerKind: "Federal"
  }
];

class EditableAcreageTable extends Component {

  constructor(props) {

    super(props);
    this.state = {
      perimeterAcreage: null
    }
  }

  componentDidUpdate = (prevProps, prevState) => 
  {
    try {
    const perimeterWasRecalculated = (this.props.perimeterWasRecalced === true && prevProps.perimeterWasRecalced === false);
    
    if (this.props.editWasCancelled === true && !prevProps.editWasCancelled) 
    {
      console.log("Edit was cancelled");
      this.setState({
        perimeterAcreage: null
      });
      this.forceUpdate();
      return;
    }

    if (perimeterWasRecalculated)  //prevProps.perimeterAcreage !== this.props.perimeterAcreage 
    {
      this.setState({
        perimeterAcreage: this.props.perimeterAcreage
      });

      this.props.resetAcreageRecalc();

      this.forceUpdate();
      return;
    }

    var clonedCopy = JSON.parse(JSON.stringify(this.props.perimeterAcreage));

    if (this.state.perimeterAcreage === null && this.props.perimeterAcreage !== null) 
    {
      this.setState({
        perimeterAcreage: clonedCopy
      });
    }

    if (prevProps.fireOccurenceRecordID !== this.props.fireOccurenceRecordID) 
    {
      this.setState({
        perimeterAcreage: clonedCopy
      });
    }
  }

    catch(e) 
    {
      console.warn('Editable Acreage table error, componentDidUpdate');
    }
  };

  acreageRemoved = (idx) => {
    let updatedProp = Object.assign({}, this.state.perimeterAcreage);
    updatedProp.AcreageRecords = [];

    for (var i = 0; i < this.state.perimeterAcreage.AcreageRecords.length; i++ ) 
    {
      if (i !== idx) 
      {
        updatedProp.AcreageRecords.push(Object.assign({}, this.state.perimeterAcreage.AcreageRecords[i]));
      }
    }
    this.setState({
      perimeterAcreage: updatedProp
    });
    
    this.props.onAcreageRemoved(idx);
  }

  addNewRow = () =>
  {
    let updatedProp = Object.assign({}, this.state.perimeterAcreage);

    updatedProp.AcreageRecords.push({
      LandownerCategoryID: 18, 
      UserProvidedAcreage: 0,
      CanEditLandowner: true,
      AcreageRecordID: -1 
    })

    this.setState({
      perimeterAcreage: updatedProp
    });

    this.props.onAddNewRow();
  }

  acreageLandownerCategoryUpdated = (idx, value) => {
    let updatedProp = Object.assign({}, this.state.perimeterAcreage);

    updatedProp.AcreageRecords[idx] = Object.assign({}, this.state.perimeterAcreage.AcreageRecords[idx]);
    updatedProp.AcreageRecords[idx].LandownerCategoryID = value;


    this.setState({
      perimeterAcreage: updatedProp
    });

    this.props.acreageLandownerCategoryUpdated(idx, value);
  }
 
 onUpdateAcreageProp = (num, idx) => {

  let updatedProp = Object.assign({}, this.state.perimeterAcreage);
  updatedProp.AcreageRecords[idx].LandownerCategoryID = this.state.perimeterAcreage.AcreageRecords[idx].LandownerCategoryID;
  updatedProp.AcreageRecords[idx].IsUserOverriden = true;
  updatedProp.AcreageRecords[idx].UserProvidedAcreage = (isNaN(num)) ? null : num;

  this.setState({
    perimeterAcreage: updatedProp
  });

  this.props.onUpdateAcreageProp(num, idx);
 }

  recalculate = () => 
  {
    let updatedProp = Object.assign({}, this.state.perimeterAcreage);
    updatedProp.AcreageRecords = [];

    /*for (var i = 0; i < this.state.perimeterAcreage.AcreageRecords.length; i++ ) 
    {
      let updateRow = Object.assign({}, this.state.perimeterAcreage.AcreageRecords[i]);
      if (updateRow.AcreageRecordID !== -1 && updateRow.CanEditLandowner === false) 
      {
        updateRow.UserProvidedAcreage = null;
        updateRow.IsUserOverriden = false;
        updatedProp.AcreageRecords.push(updateRow);
      } 
    }*/

    this.setState({
      perimeterAcreage: updatedProp
    });

    this.props.onRecalculate();
  } 


  getSummaryRow = () => {
    return (this.state.perimeterAcreage && this.state.perimeterAcreage.AcreageRecords) ? 
    (
      <TableRow>
        <TableCell style={{ color: "#6495ED", fontWeight: "bold" }}>Total:</TableCell>
        <TableCell align="left"></TableCell>
        <TableCell align="left" style={{ color: "#6495ED", fontWeight: "bold" }}>{this.state.perimeterAcreage.AcreageRecords.reduce((pv, cv) => pv + ((cv.UserProvidedAcreage !== null) ? parseFloat(cv.UserProvidedAcreage) : parseFloat(cv.CalculatedAcreage)), 0).toFixed(2).toLocaleString()}</TableCell>
        <TableCell></TableCell>
      </TableRow>
    ) :
      (<TableRow/>)
  }

  render() {

    return (
      <Table>
          <TableHead>
            <TableRow>
              <TableCell align="left" style={{ color: "#6495ED", fontWeight: "bold" }}>Landowner Kind</TableCell>
              <TableCell align="left" style={{ color: "#6495ED", fontWeight: "bold" }}>Landowner Category</TableCell>
              <TableCell align="left" style={{ color: "#6495ED", fontWeight: "bold" }}>Calculated Acres</TableCell>
              <TableCell align="left" style={{ color: "#6495ED", fontWeight: "bold" }}>User Acres</TableCell>
              <TableCell align="left" style={{ color: "#6495ED", fontWeight: "bold" }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(this.state.perimeterAcreage && this.state.perimeterAcreage.AcreageRecords) ?
              (
                this.state.perimeterAcreage.AcreageRecords.map((row, idx) => (
                  <TableRow key={row.LandownerCategoryID}>
                    <TableCell align="left">
                      {Landowners.find(s => s.LandownerCategoryID === row.LandownerCategoryID).LandownerKind}
                    </TableCell>
                    <TableCell align="left">
                      <Select
                        style={{ width: "160px" }}
                        disabled={(this.props.mode === "read" || !row.CanEditLandowner || this.props.shouldDisable)}
                        value={row.LandownerCategoryID}
                        onChange={(event) => {
                          this.acreageLandownerCategoryUpdated(idx, event.target.value);
                        }}>
                        {
                          Landowners.map(landownerValue => {
                            return (
                              <MenuItem value={landownerValue.LandownerCategoryID} key={landownerValue.LandownerCategoryID}>
                                {landownerValue.Code}
                              </MenuItem>
                            );
                          }
                          )}
                      </Select>
                    </TableCell>
                    <TableCell align="left">
                      <TextField
                        name={'txt' + idx + row}
                        key={'calcAcres' + row.LandownerCategoryID}
                        style={{ width: "110px" }}
                        value={Number(row.CalculatedAcreage).toFixed(2) }
                        type="number"
                        disabled={true} />
                    </TableCell>
                    <TableCell align="left">
                      <TextField
                        name={'txt' + idx + row}
                        key={'userCanEdit' + row.LandownerCategoryID}
                        style={{ width: "110px" }}
                        defaultValue={Number(row.UserProvidedAcreage).toFixed(2)}
                        type="number"
                        onChange={(event, value) => {
                          event.preventDefault();
                          const num = parseFloat(value)
                          this.onUpdateAcreageProp(num, idx);
                        }}
                        disabled={this.props.mode === "read" || this.props.shouldDisable} /></TableCell>
                    <TableCell align="left">
                      <IconButton
                        color="inherit"
                        style={(this.props.mode !== "read") ? { position: "relative", float: "right", marginLeft: "auto" } : { display: 'none' }}
                        aria-label="close"
                        disabled={(this.props.mode === "read" || !row.CanEditLandowner || this.props.shouldDisable)}
                        onClick={(e) => {
                          this.acreageRemoved(idx);
                        }}>
                        <CloseIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              )
              :
              (<TableRow/>)
            }
            {this.getSummaryRow()}

            <TableRow style={(this.props.mode !== "read") ? { marginLeft: "auto" } : { display: 'none' }}>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell>
                <Button size="small" color="primary" variant="contained"
                  disabled={(this.props.mode === "read" || this.props.shouldDisable)}
                  onClick={(e) => {
                    this.addNewRow();
                  }}>Add Row</Button>
              </TableCell>
              <TableCell>

                <Button size="small" color="primary" variant="contained"
                  onClick={(e) => {
                    this.recalculate();
                  }}
                  disabled={!this.props.perimeter || !this.props.perimeter.Feature || !this.props.perimeterAcreage || this.props.shouldDisable }>Recalculate</Button>

              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
    )
  }
}

export default EditableAcreageTable;
